import { useEffect } from "react";
import { PolicyDetails } from "shared";

import { unstable__Button as Button } from "@hagerty/react-components";

import Warning from "../../../svg/warning.svg";
import { Dialog } from "../../Dialog";
import style from "./RemoveLastVehicleDialog.module.scss";
import { useFeatureFlag, useUrls } from "../../../app/Providers/AppContext";
import { TagAction } from "../../../types/Tag.types";
import { mt } from "../../../utils/tracking";

const cancelPolicyTagAction: TagAction = {
  actionName: "Cancel policy",
  actionType: "link",
};
const addVehicleTagAction: TagAction = {
  actionName: "Add a new vehicle",
  actionType: "button",
};

type RemoveLastVehicleDialogProps = {
  policy: PolicyDetails;
  onClose: () => void;
};

export const RemoveLastVehicleDialog = ({
  policy,
  onClose,
}: RemoveLastVehicleDialogProps) => {
  const urls = useUrls();
  const { ADD_VEHICLE } = useFeatureFlag();
  const cancelPolicyUrl = urls.insurance.cancelPolicy(policy.country);
  const addVehicleUrl = urls.insurance.addVehicle(
    policy.policyNumber,
    policy.country,
    ADD_VEHICLE.treatment
  );

  useEffect(() => mt.trackPopup("Cancel policy"), []);

  const closeDialog = () => {
    mt.trackPopupClose();
    onClose();
  };

  return (
    <Dialog
      size="medium"
      label="Last vehicle on policy dialog"
      onDismiss={closeDialog}
    >
      <div className={style.dialogBodyWrapper}>
        <img width={48} src={Warning} alt="Warning" aria-hidden="true" />
        <div className={style.dialogTitle}>Remove vehicle</div>
        <div className={style.dialogMessage}>
          You may not remove the last vehicle on your policy. To keep this
          policy you will need to add another vehicle prior to removing this
          vehicle.
        </div>
        <div className={style.dialogActions}>
          <Button
            variant="outline"
            color="blueberry"
            href={addVehicleUrl}
            aria-label={`Add a new vehicle to policy ${policy.policyNumber}`}
            onClick={() => mt.trackAction(addVehicleTagAction)}
          >
            Add a new vehicle
          </Button>
        </div>
        <div className={style.dividerWrapper}>
          <div className="divider" />
        </div>
      </div>
      <div className={style.dialogFooter}>
        Don't have another vehicle to add?
        <Button
          variant="text"
          size="medium"
          color="blueberry"
          className={style.cancelPolicyLink}
          href={cancelPolicyUrl}
          aria-label={`Cancel policy ${policy.policyNumber}`}
          onClick={() => mt.trackAction(cancelPolicyTagAction)}
        >
          Cancel policy
        </Button>
      </div>
    </Dialog>
  );
};
